import { KeyRoundIcon, LinkIcon, LogOutIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { McpCatalogPanel } from '@/features/admin/ui/McpCatalog';

import { AdminPageShell } from '../AdminPageShell';

/**
 * The frame supplies the surface and its inset; the page supplies its heading and
 * the catalog. `ownsBodyInset` is deliberately not passed: the toolbar and table
 * below carry no padding of their own, so the body card's single inset is the only
 * one — the shape Knowledge Files uses, where a toolbar and a table sit on one
 * padded card rather than on a card inside another.
 */
export const McpCatalogPage = () => {
  const { t } = useTranslation('admin');

  return (
    <AdminPageShell
      title={t('admin.mcpCatalogPage.mcpCatalog')}
      about={{
        title: t('admin.mcpCatalogPage.about.title'),
        description: t('admin.mcpCatalogPage.about.description'),
        rows: [
          { icon: LinkIcon, text: t('admin.mcpCatalogPage.about.addServerByUrl') },
          { icon: KeyRoundIcon, text: t('admin.mcpCatalogPage.about.chooseHowPeopleSignIn') },
          { icon: LogOutIcon, text: t('admin.mcpCatalogPage.about.credentialChangesSignOut') },
        ],
      }}
    >
      <McpCatalogPanel />
    </AdminPageShell>
  );
};
